<template>
    <div>
        <button :class="getButtonClass()" @click="handleAppleSignIn">
            <div class="button__google--icon">
                <common-icon name="apple" size="huge"></common-icon>
            </div>
            <span>{{ $t('forms.auth.signup.buttons.continue_with_apple') }}</span>
        </button>
    </div>
</template>

<script>
    import Store from '~/store'
    import AuthAPI from 'api/AuthAPI'
    import LoginType from 'enums/login_type.enum'
    import RoutesEnum from 'enums/routes.enum'

    export default {
        methods: {
            async handleAppleSignIn() {
                if (this.$auth.isSubdomainActive() && !Store.getters['data/getSubdomainCompany'].googleLoginEnabled) {
                    return
                }

                try {
                    const response = await window.AppleID.auth.signIn()
                    const query = {
                        id_token: response.authorization.id_token,
                    }

                    if (response.user?.name) {
                        query.firstName = response.user.name.firstName
                        query.lastName = response.user.name.lastName
                    }

                    await this.loginUser(query)
                } catch (err) {
                    console.error({ message: 'Apple Sign-In failed', data: err })
                }
            },

            createSession(data) {
                this.$auth.createSession({
                    accessToken: data.access_token,
                    refreshToken: data.refresh_token,
                    loginType: LoginType.APPLE,
                })

                this.$router.push({ name: RoutesEnum.INDEX.HOME })
            },

            async loginUser(query) {
                const res = await AuthAPI.loginApple({
                    accessToken: query.id_token,
                    firstName: query.firstName,
                    lastName: query.lastName,
                    language: this.$i18n.locale,
                })

                this.createSession(res.payload)
            },

            async handleAppleSignInSuccess(event) {
                const query = {
                    id_token: event.detail.authorization.id_token,
                }

                if (event.detail.user?.name) {
                    query.firstName = event.detail.user.name.firstName
                    query.lastName = event.detail.user.name.lastName
                }

                await this.loginUser(query)
            },

            handleAppleSignInFailure(event) {
                console.error({
                    message: 'Something went wrong',
                    data: event,
                })
            },

            getButtonClass() {
                return {
                    button__google: true,
                    button__apple: true,
                    'button__google-disabled':
                        this.$auth.isSubdomainActive() && !Store.getters['data/getSubdomainCompany'].googleLoginEnabled,
                }
            },
        },

        mounted() {
            window.AppleID.auth.init({
                clientId: process.env.VUE_APP_APPLE_CLIENT_ID,
                scope: 'name email',
                redirectURI: window.location.href.split('/#')[0],
                usePopup: true,
            })

            window.addEventListener('AppleIDSignInOnSuccess', this.handleAppleSignInSuccess)
            window.addEventListener('AppleIDSignInOnFailure', this.handleAppleSignInFailure)
        },

        destroyed() {
            window.removeEventListener('AppleIDSignInOnSuccess', this.handleAppleSignInSuccess)
            window.removeEventListener('AppleIDSignInOnFailure', this.handleAppleSignInFailure)
        },
    }
</script>
